import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom'
import './App.css';

import Navbar from './components/Navbar.jsx'
import Footer from './components/Footer.jsx'
import Videos from './components/videos/Videos.jsx'
import Best from './components/videos/Best.jsx'
import New from './components/videos/New.jsx'
import Edit from './components/videos/Edit.jsx'
import About from './components/About.jsx'

class App extends Component {
  render() {
    return (
      <Router basename={'/videos'}>
        <div className="App">
          <Navbar />
          <div className="content-wrap clearfix">
            <Route exact path='/' component={Videos} />
            <Route path='/best' component={Best} />
            <Route path='/new' component={New} />
            <Route path='/edit' component={Edit} />
            <Route path='/about' component={About} />
          </div>
          <Footer />
        </div>
      </Router>  
    );
  }
}

export default App;
